import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

class TermsPartnerPage extends React.Component {
  render() {
    return (
      <Layout>
        <SEO />
        <div className="terms-partner">
          <section>
            <div className="container is-slim">
              <div className="mt-40 has-text-centered">
                <h2 className="title is-2">PICKS利用規約（販売者）</h2>
              </div>
              <div className="mt-40 mlr-20-mobile">
                <div>
                  <div className="ma-10">
                    このPICKS利用規約（販売者）（以下「本規約」といいます）は、株式会社DIRIGIO（以下「当社」といいます）が提供するモバイルオーダー立ち上げサービス「PICKS（ピックス）」（以下「本サービス」といいます）の利用に関する契約（以下「本契約」といいます）の条件を、本サービスを利用して商品を販売する者（以下「販売者」といいます）と当社との間で定めるものです。
                  </div>
                  <div>1. 本サービスの概要</div>
                  <div className="ma-10">
                    本サービスは、モバイルオーダーの立ち上げを支援するプラットフォームを提供するサービスです。本サービスの内容は当社が別途提供する資料等（以下「資料等」といいます）をご参照ください。なお、当社は、本サービスを継続的に改良しており、これに伴い本サービスの内容も変化することから、資料等はあくまでご参考として提供するものであり、本サービスの内容が資料等のとおりであることを保証するものではないことをご了承ください。{" "}
                  </div>
                  <div>2. 利用登録</div>
                  <div className="ma-10">
                    本サービスをご利用いただくには利用登録が必要です。利用登録は、本規約に同意し、当社所定の方法で当社所定のサービスプランに申込み、当社が当該申込みを承諾した場合に完了し、この時、選択されたサービスプランに応じた本契約が成立します。
                    <br />
                    当社は、当社がその裁量により定める審査基準に満たない申込みを承諾しないことができます。当社は、審査基準及び承諾をお断りする理由を開示する義務を負いません。
                    <br />
                    販売者は、利用登録の際に当社の指定にしたがって真実かつ正確な情報を登録し、かつ、当該情報を常に最新の情報となるよう随時更新するものとします。
                    <br />
                    販売者は、利用登録された本サービスのアカウントを他者に利用されないよう厳重に管理するものとし、当社は販売者のアカウントを使用して行われた一切の行為を、販売者自身の行為とみなすことができるものとします。
                  </div>
                  <div>3. 本サービスの利用</div>
                  <div className="ma-10">
                    当社は、販売者に対して、本契約の有効期間中、本契約にしたがって本サービスを利用する権利を、非独占的に許諾します。販売者は、本規約及び適用法令を遵守して本サービスを利用し、かつ、販売者の役職員をして、本規約及び適用法令を遵守させるものとします。
                    <br />
                    本サービスを利用するために必要な端末機器やインターネット接続等は、販売者の費用と責任で用意しなければなりません。
                    <br />
                    販売者は、商品の注文、キャンセル、テイクアウト、第5項に定める引渡サービスマッチング、第6項に定める提携サービスマッチング、決済、その他、本サービスの機能について、その設定、操作方法、時間（期限）、その他の利用条件に関する本サービスの仕様に習熟していなければなりません。当社は、販売者が本サービスの仕様を知らず又は誤解したことにより販売者に生じた損害について責任を負いません。
                    <br />
                    当社は、商品の注文、キャンセル、テイクアウト、デリバリー、決済、その他、本サービスの利用に関して、販売者に連絡を行う場合、本サービス内の通知の他、販売者が登録した連絡先への連絡を行うことがあり、販売者はこれらの通知、連絡を常時確実に受けられるようにしておくものとします。{" "}
                  </div>
                  <div>4. 商品売買契約</div>
                  <div className="ma-10">
                    販売者が本サービスを通じて販売者の飲食物（以下「商品」といいます）を本サービスのユーザー（以下「ユーザー」といいます）に販売した場合、販売者を売主、当該ユーザーを買主として、本商品の売買契約（以下「商品売買契約」といいます）が成立します。当社は、商品の商品売買契約の当事者ではありません。
                    <br />
                    販売者は、食品衛生法、景品表示法、特定商取引に関する法律、個人情報の保護に関する法律、その他の適用法令及び監督官庁のガイドライン等を遵守して、商品売買契約を誠実に履行しなければならず、商品売買契約に関して何らかの問題が発生した場合、販売者は自らの責任と費用でこれを解決するものとし、当社に一切の迷惑を及ぼさないものとします。
                    <br />
                    当社は、販売者が商品売買契約の勧誘、成立又は履行に関して適切な対応をしていないと合理的に判断した場合、ユーザー、販売者、当社、その他の第三者の権利利益を保護するために当社が必要かつ適切と判断する措置を講じることができ、販売者はかかる措置に異議を述べないものとします。
                    <br />
                    原則として、商品は、販売者が販売する飲食物でなければなりません。ただし、販売者が希望し、当社が別途承諾した場合、販売者と提携関係にある一定の者（以下「販売者提携先」といいます）が販売する飲食物を商品とすることができます。この場合、販売者は、販売者提携先をして、(a)本契約の範囲内で本サービスを利用させ、(b)本規約のうち、販売者に課せられる義務及び責任を遵守させ（これにより販売者が本契約上の義務及び責任を免れるものではありません）、(c)本規約に定める当社、ユーザー、その他の第三者の権利、権限及び利益（当社が商品の代金（以下「商品代金」といいます）を販売者提携先ではなく販売者に支払うことを含みます）を承認させ、(d)当社から受領した商品代金を、販売者と販売者提携先との間の契約に基づいて、適時に販売者提携先に支払い、(d)販売者提携先が本サービスを利用したことに起因して、ユーザー、その他の第三者から、当社に対して、苦情、警告、異議、請求、訴訟、その他の紛争（以下、総称して「紛争等」といいます）の提起があった場合、販売者は自らの責任と費用により紛争等を解決し、当社に一切の迷惑を及ぼさないものとします。なお、この場合、本規約中、販売者を表す部分は、必要に応じて適宜、販売者提携先を含むものとして解釈適用されるものとします。{" "}
                  </div>
                  <div>5. 引渡サービス</div>
                  <div className="ma-10">
                    当社は、本サービスにおいて、商品の引渡しに関するサービス（デリバリー、ピックアップボックス等を含みますが、これらに限りません。以下「引渡サービス」といいます）を行う業者（以下「引渡サービス業者」といいます）をサーチしてマッチングする機能（以下「引渡サービスマッチング」といいます）を提供します。販売者は、引渡サービスマッチングがマッチングの成功を保証するものではなく、引渡サービス業者の繁忙その他の理由によりマッチングできない場合があることを了承のうえ引渡サービスマッチングを利用するものとします。
                    <br />
                    販売者は、引渡サービスマッチングを利用する場合、引渡サービスに関する引渡サービス業者との契約（以下「引渡サービス契約」といいます）の締結、引渡サービス業者のサービスアカウントの開設、その他、本サービスにしたがって、引渡サービスに必要な行為を行うものとします。引渡サービス契約の内容（引渡サービス業者による引渡サービス業務の提供条件及び引渡サービス料金を含みます）は、引渡サービス業者が定める利用約款等（名称を問いません）に基づいて決定されるものとし、販売者はこれを承諾して引渡サービスを利用するものとします。引渡サービス契約は本サービスでマッチングが成功した時点で自動的に成立します。引渡サービス契約に関して何らかの問題が発生した場合、販売者は自らの責任と費用でこれを解決するものとし、当社に一切の迷惑を及ぼさないものとします。
                  </div>
                  <div>6. 提携サービス</div>
                  <div className="ma-10">
                    当社は、本サービスにおいて、引渡サービス以外にも、当社の提携する業者（以下「提携サービス業者」といいます）の提供するサービス（以下「提携サービス」といいます）に関してマッチングする機能（以下「提携サービスマッチング」といいます）を提供することができます。ただし、当社は、提携サービスマッチングを提供する義務を負うものではなく、当社の判断により、対象となる提携サービスを変更し、又は提携サービスマッチングの提供を終了することができます。
                    <br />
                    販売者は、提携サービスマッチングがマッチングの成功を保証するものではなく、提携サービス業者の繁忙その他の理由によりマッチングできない場合があることを了承のうえ提携サービスマッチングを利用するものとします。
                    <br />
                    販売者は、提携サービスマッチングを利用する場合、提携サービスに関する提携サービス業者との契約（以下「提携サービス契約」といいます）の締結、提携サービス業者のサービスアカウントの開設、その他、本サービスにしたがって、提携サービスに必要な行為を行うものとします。提携サービス契約の内容（提携サービス業者による提携サービス業務の提供条件及び提携サービス料金を含みます）は、提携サービス業者が定める利用約款等（名称を問いません）に基づいて決定されるものとし、販売者はこれを承諾して提携サービスを利用するものとします。提携サービス契約は本サービスでマッチングが成功した時点で自動的に成立します。提携サービス契約に関して何らかの問題が発生した場合、販売者は自らの責任と費用でこれを解決するものとし、当社に一切の迷惑を及ぼさないものとします。
                  </div>
                  <div>7. オリジナルサイト・オリジナルアプリ</div>
                  <div className="ma-10">
                    当社は、本サービスにおいて、販売者の商品を掲載し、商品のモバイルオーダーが可能なウェブサイト（以下「オリジナルサイト」といいます）並びにiOS端末及びAndroid端末向けのアプリケーション（以下「オリジナルアプリ」といいます）を提供します。多数の販売者にオリジナルサイト及びオリジナルアプリを効率的かつ安価に提供するため、オリジナルサイト及びオリジナルアプリのデザイン、機能、その他の仕様は、当社が画一的に決定し、必要に応じて適宜変更します。オリジナルサイト及びオリジナルアプリの利用は、本契約後、両当事者間で別途合意する時期から可能となります。
                    <br />
                    販売者は、当社がオリジナルサイト及びオリジナルアプリの制作、その他の提供準備を行うにあたり必要な協力を求めた場合、適時に協力するものとします。
                    <br />
                    原則として、オリジナルサイトは当社が管理するドメイン内に設置され、また、オリジナルアプリは当社が管理するAppleおよびGoogleのDeveloperアカウントからアプリマーケットに掲載され、ユーザーとの関係では当社がこれらの運営主体となります。ただし、販売者が希望し、当社が別途承諾した場合、オリジナルサイトを販売者が管理するドメイン内に設置し、また、オリジナルアプリを販売者が管理するAppleおよびGoogleのDeveloperアカウントからアプリマーケットに掲載することができます。この場合、(a)ユーザーとの関係では販売者がオリジナルサイト及びオリジナルアプリの運営主体となり、(b)利用するドメイン、Developerアカウント等の維持管理は販売者の費用と責任で行うものとし、(c)当社が指定する利用規約及びプライバシーポリシーをオリジナルサイト及びオリジナルアプリ（さらに、必要に応じてアプリマーケットの掲載ページ）に掲載するものとし、(d)本契約の終了に際して、当社の指示にしたがって、オリジナルサイト及びオリジナルアプリのユーザーへの提供を終了するものとします。
                  </div>
                  <div>8. メディア掲載</div>
                  <div className="ma-10">
                    当社は、本サービスにおいて、店舗紹介、メニュー、価格、その他、店舗及び商品に関するテキスト、写真、その他の情報（以下「掲載情報」といいます）を、オリジナルサイト、オリジナルアプリ、当社が「PICKS」の名称で運営するモバイルオーダーが可能なメディア（以下「当社メディア」といいます）及び当社と提携する他者のメディア（以下「提携メディア」といいます）に掲載する機能を提供します。
                    <br />
                    販売者は、掲載を希望する情報に加え、特定商取引に関する法律に基づいて表示を義務付けられる情報、その他、当社が合理的に指定する情報を、当社所定の方法で、掲載情報として本サービスに登録するものとします。販売者は、掲載情報が真実かつ正確であり、法令若しくは公序良俗に違反する情報又は誤解を招くおそれのある情報を含んでいないことを保証するものとします。掲載情報に関して、ユーザー、その他の第三者から、当社又は掲載メディアの運営者に対して紛争等の提起があった場合、販売者は自らの責任と費用により紛争等を解決するものとし、当社及び掲載メディアの運営者に一切の迷惑を及ぼさないものとします。
                    <br />
                    当社は、掲載情報が真実又は正確でない場合、法令又は公序良俗に違反する場合、誤解を招くおそれがある場合、その他、当社が不適切と判断した場合、販売者に対し掲載情報の訂正を求めることができ、販売者は直ちに訂正に応じるものとします。販売者がかかる訂正に応じない場合又は当社が緊急を要すると判断した場合、当社は販売者の承諾なく、掲載情報の全部又は一部を削除又は訂正することができるものとします。{" "}
                  </div>
                  <div>9. 決済</div>
                  <div className="ma-10">
                    当社は、本サービスにおいて、当社が適宜選択するペイメントサービスプロバイダー（以下「PSP」といいます）の決済サービス（以下「決済サービス」といいます）を利用して商品代金を決済することができる機能を提供します。
                    <br />
                    販売者は、決済サービスに関するPSPとの契約（以下「決済サービス契約」といいます）の締結、PSPのサービスアカウントの開設、その他、本サービスにしたがって、決済サービスを利用するために必要な行為を行うものとします。決済サービス契約の内容は、PSPが定める利用約款等（名称を問いません）に基づいて決定されるものとし、販売者はこれを承諾して決済サービスを利用するものとします。
                    <br />
                    当社は、PSPから商品代金を代理受領し、これを当社所定の支払いサイクル（なお、未払いの商品代金の累計総額が当社所定の金額に満たない場合、当社は次回の支払いサイクルに支払いを繰り延べることができるものとします。また、PSPの仕様上、商品代金が決済されてからPSPにおいて振込処理が可能となるまで、及び、当社がPSPにおいて振込処理を行なってから販売者の指定する金融機関口座に振り込まれるまで、にタイムラグが生じるため、これに起因して販売者に商品代金が支払われる時期が遅くなる場合があります）で、販売者の指定する金融機関口座に振り込んで、販売者に支払います。振り込みに必要な費用は販売者の負担とします。なお、商品売買契約の売主が販売者提携先である場合であっても、当社は、商品代金を販売者に支払うことで足り、この場合、販売者は、当社が販売者に商品代金を支払うことをあらかじめ承諾させ、自らの責任と費用で、販売者と販売者提携先との間の契約にしたがって、適時に、商品代金を販売者提携先に支払うものとします。
                    <br />
                    販売者は、当社及びPSPに対して、商品代金を代理受領する権限を付与するものとします。さらに、販売者は、PSPの要請により必要となる場合には、商品代金債権を当社又はPSPに譲渡することに同意します。{" "}
                  </div>
                  <div>10. 利用料</div>
                  <div className="ma-10">
                    販売者は、本サービスの対価として、利用期間中、当社に対し、当社が別途定めるサービスプランに応じた利用料（以下「利用料」といいます）を、当社が別途指定する方法で支払うものとします。当社は一度受領した利用料を返金する義務を負いません。利用料の支払いに際して、金融機関の振込手数料が発生する場合、販売者の負担とします。販売者が、利用料の支払いを遅延した場合、当社は、支払期限の翌日から支払済みまで年14.6%の遅延損害金を請求することができます。
                    <br />
                    販売者が当社に対して商品代金債権、その他、何らかの反対債権を有する場合、当社は、販売者の期限の利益の有無にかかわらず、当該反対債権と利用料債権、その他、当社が販売者に対して有する債権とを対当額で相殺することができるものとします。かかる相殺は、商品代金の振込み時に商品代金から控除する方法、その他、適宜の方法で行われます。{" "}
                  </div>
                  <div>11. マーケティング活動への協力</div>
                  <div className="ma-10">
                    当社は、本サービスのマーケティング活動として、ユーザーに、クーポンやリワードの提供、その他のマーケティング活動を行うことがあり、販売者は、合理的範囲内でこれに協力するものとします。{" "}
                  </div>
                  <div>12. 本サービスの中断</div>
                  <div className="ma-10">
                    以下の事由が発生した場合、当社は、販売者に事前に連絡することなく、一時的に本サービスの提供を中断することがあり、販売者は予めこれを承諾するものとします。
                    <br />
                    (a)本サービスのシステムの保守を定期的に又は緊急に行う場合
                    <br />
                    (b)本サービスを提供するために必要となる当社又は第三者の通信設備、ソフトウェア、クラウドサービス、その他の製品又はサービスが障害、提供終了、その他の事由により利用できない場合
                    <br />
                    (c)天災、感染症の大流行、戦争、暴動、騒乱、労働争議、火災、停電、事故、法規制の変更、裁判所の命令、政府機関の要請、その他、不可抗力により本サービスを提供できない場合
                    <br />
                    (d)その他、運用上、技術上、当社が本サービスの一時的な中断を必要と判断した場合{" "}
                  </div>
                  <div>13. 本サービスの変更</div>
                  <div className="ma-10">
                    当社は、必要に応じてオリジナルサイト、オリジナルアプリ、当社メディアを含む本サービスの内容を改良、拡張、その他、変更することがあり、販売者は予めこれを承諾するものとします。{" "}
                  </div>
                  <div>14. 本サービスの終了</div>
                  <div className="ma-10">
                    法令、税制、経済情勢、社会情勢、本施設及び本サービスの需要、当社の経営環境、その他、諸般の事情により当社がやむを得ないと判断した場合、当社は、相当な期間をおいて予告したうえで（ただし、緊急の場合は事後に連絡することにより）オリジナルサイト、オリジナルアプリ、当社メディアを含む本サービスの全部又は一部を終了することがあり、販売者は予めこれを承諾するものとします。{" "}
                  </div>
                  <div>15. 禁止行為</div>
                  <div className="ma-10">
                    販売者は、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。
                    <br />
                    (a) 本規約等に違反する行為
                    <br />
                    (b) 法令に違反する行為
                    <br />
                    (c) 他者の権利を侵害する行為
                    <br />
                    (d) 公の秩序又は善良の風俗を害するおそれのある行為
                    <br />
                    (e) 他者に不当な要求をする行為
                    <br />
                    (f) 他者や架空の人物になりすます行為
                    <br />
                    (g) 不正に他者の個人情報その他の情報を収集し又はアクセスする行為
                    <br />
                    (h) 当社の承諾なく本サービスで飲食物以外の商品又は役務を販売する行為、その他、本サービスが予定しない目的又は態様での本サービスを利用する行為
                    <br />
                    (i) 本サービスの運営及び他者による本サービスの利用を妨害し又は支障を与える行為
                    <br />
                    (j) 当社又は本サービスの信用、ブランド、イメージを毀損する行為
                    <br />
                    (k) 上記各号のいずれかに該当するおそれのある行為又はこれを助長する行為
                    <br />
                    (l) その他、当社が不適切と判断する行為
                    <br />
                    当社は、販売者の行為が上記禁止事項に該当すると判断した場合、事前に販売者に通知することなく以下の措置を講じることができ、販売者はこれに異議を述べないものとします。当社は、以下の措置により販売者に何らかの損害が生じた場合であっても責任を負いません。また、以下の措置は、当社の販売者に対する損害賠償請求を妨げません。
                    <br />
                    (a) 本契約の解除
                    <br />
                    (b) 販売者に対する本サービスの提供停止
                    <br />
                    (c) 禁止事項に該当する行為の差止め又は是正の請求
                    <br />
                    (d) 捜査機関、行政機関、裁判所、被害者、その他の第三者に対する情報提供
                    <br />
                    (e) その他、当社又は他者の権利利益を保護するために、当社が必要かつ適切と判断する措置{" "}
                  </div>
                  <div>16. データの取扱い</div>
                  <div className="ma-10">
                    当社は、販売者が本サービスを利用したことにより本サービスのシステムに入力、生成、保存されるデータ（以下「利用データ」といいます）を、以下の目的で利用することができます。ただし、当社は、下記(c)以外の目的で利用データを第三者に開示又は提供しようとする場合、販売者の事前の承諾を得るものとします。
                    <br />
                    (a) 本サービスの提供、保守及び改善
                    <br />
                    (b) 分析、統計、研究及び開発
                    <br />
                    (c) 当社又は第三者の法的権利の保護及び行使
                    <br />
                    当社は、利用データを分析した結果生成される統計データ（販売者、販売者提携先及びユーザーを特定できないものに限ります）を、当社の事業上の必要に応じて、第三者への開示及び公表を含め、自由に利用することができます。
                    <br />
                    利用データの適法性、有効性、正確性、確実性、安全性、最新性、完全性等に関する責任は販売者が負うものとします。当社が、本契約にしたがって利用データを処理し、その他、利用データを利用したにもかかわらず、万一、第三者の知的財産権、プライバシー権、その他、法令上若しくは契約上の権利を侵害し、又は、適用法令に違反することとなった場合、販売者は、当社に害が及ばないよう最大限努力するとともに、これに起因して当社が被った損害（合理的な弁護士費用を含みますが、これに限られません）を賠償するものとします。{" "}
                  </div>
                  <div>17. 個人情報の取扱い</div>
                  <div className="ma-10">
                    当社は、個人情報を当社のプライバシーポリシーにしたがって適切に取扱います。販売者は、本サービスを利用して取得した個人情報を、本サービスの利用以外の目的で利用することはできません。{" "}
                  </div>
                  <div>18. 権利帰属</div>
                  <div className="ma-10">
                    オリジナルサイト、オリジナルアプリ、当社メディアを含む本サービスを構成するソフトウェア、プログラム、データベース、画像、映像、文章、その他の有形又は無形の資産（ただし、利用データ及び掲載情報を除きます）に関する特許権（特許を受ける権利を含みます）、実用新案権（実用新案登録を受ける権利を含みます）、意匠権（意匠登録を受ける権利を含みます）、商標権、著作権、その他一切の権利は、当社に帰属します。
                    <br />
                    販売者は、本サービスについて、リバースエンジニアリング、デコンパイル、逆アセンブル、その他、本サービスの解析を目的とする行為を行わないものとします。{" "}
                  </div>
                  <div>19. 保証の否認</div>
                  <div className="ma-10">
                    オリジナルサイト、オリジナルアプリ、当社メディアを含む本サービスは「現状有姿」で提供されます。当社は、本サービスに関して、中断がないこと、バグやエラーがないこと、適切な品質を有すること、有害な内容を含まないこと、特定の目的に適合すること、データが消失又は損傷しないことの保証を含め、明示的にも黙示的にも、法定のものであるかその他のものであるかに関わらず、いかなる保証もできません。{" "}
                  </div>
                  <div>20. 責任限定</div>
                  <div className="ma-10">
                    当社は、当社の故意又は重大な過失による場合を除き、オリジナルサイト、オリジナルアプリ、当社メディアを含む本サービスの中断、変更又は終了に起因する損害、データの消失、損傷、漏洩に起因する損害、その他、本サービスに起因して販売者に生じる損害について責任を負いません。
                    <br />
                    何らかの理由により当社が販売者に対し責任を負う場合であっても、当社の損害賠償責任の累計総額は、責任の原因が発生した時から遡って1ヶ月分の利用料を超えないものとし、かつ、付随的損害、派生的損害、偶発的損害、間接損害、特別損害、将来の損害及び逸失利益について賠償する責任を負わないものとします。{" "}
                  </div>
                  <div>21. 秘密保持</div>
                  <div className="ma-10">
                    各当事者は、本契約に関して相手方より開示を受けた相手方の営業上又は技術上の秘密であって、相手方が秘密である旨明示した情報並びにその内容、性質及び開示の状況から秘密とすることが期待される情報（以下「秘密情報」といいます）を、相手方の事前の書面による承諾なしに、かかる開示の目的以外の目的で利用せず、かつ、第三者に開示又は漏洩しないものとします。ただし、以下のいずれかに該当する情報は秘密情報に含まれません。また、各当事者は、秘密情報のうち法令に基づき開示を強制された情報を、当該法令に基づく開示先に対し開示することができます。なお、秘密情報が利用データである場合、第7項（データの取扱い）の規定は本条に優先して適用されます。
                    <br />
                    (a) 開示を受けた時点で第三者に対する秘密保持義務を負うことなく保有していた情報
                    <br />
                    (b) 開示を受けた時点で公知であった情報
                    <br />
                    (c) 開示を受けた後に自らの責めに帰すべき事由によらず公知となった情報
                    <br />
                    (d) 開示を受けた後に第三者に対して秘密保持義務を負うことなく適正に取得した情報
                    <br />
                    (e) 秘密情報によらずに独自に開発した情報 {" "}
                  </div>
                  <div>22. 公表</div>
                  <div className="ma-10">
                    当社は、本サービスの宣伝広告活動において、販売者による本サービスの利用を公表することができます。販売者は、かかる公表に際し、当社が販売者の商標及びロゴを使用することを予め承諾します。{" "}
                  </div>
                  <div>23. 解除</div>
                  <div className="ma-10">
                    本契約は、販売者が選択したサービスプランに応じて、所定の契約期間存続し、販売者が契約期間の終期の1ヶ月前までに当社に更新拒絶の意思表示をしない場合、同一条件で自動的に更新されます。契約期間中の中途解約は承っておりませんので、契約期間をあらかじめよくご確認ください。
                    <br />
                    各当事者は、相手方が以下のいずれかに該当する場合、直ちに本契約を解除することができます。かかる解除権の行使は相手方に対する損害賠償請求を妨げません。
                    <br />
                    (a) 本契約に違反し、相当の期間を定めて催告しても違反状態を是正しない場合
                    <br />
                    (b) 重大な法令違反、その他、社会的信用を失墜させる行為を行い、本契約の継続が相応しくないと合理的に判断される場合
                    <br />
                    (c) 仮差押、仮処分、差押、公租公課の滞納処分又は競売開始があった場合、破産、民事再生、会社更生、特別清算、その他の倒産手続の申立てがあった場合、その他財務状態が著しく悪化し又はそのおそれがあると合理的に判断される場合{" "}
                  </div>
                  <div>24. 本契約の終了</div>
                  <div className="ma-10">
                    本契約が終了する場合、当社は、本契約終了前の合理的な時期に、商品売買契約の勧誘、成立及び履行のための本サービスの機能、オリジナルサイト及びオリジナルアプリの提供、掲載情報の掲載を終了させることができるものとします。
                    <br />
                    本契約の終了に際して、販売者は、返還又は破棄すべき物品又はデータがある場合、当社の指示にしたがって、返還又は破棄するものとします。
                    <br />
                    理由を問わず本契約が終了した場合であっても、第16項（データの取扱い）、第18項（権利帰属）、第19項（保証の否認）、第20項（責任限定）、第21項（秘密保持）、本項、第28項（準拠法・管轄）、その他、本契約の終了後も効力を存続させることが予定された規定については、その規定する事項が存する限り有効とします。{" "}
                  </div>
                  <div>25. 本規約の変更</div>
                  <div className="ma-10">
                    当社は、必要に応じて本規約を変更することがあります。本規約を変更する場合、当社は、変更内容に応じて適切な変更手続を実施します。なお、販売者一般の利益に適合する場合又は本規約の目的に反せず、法令、税制、経済情勢、社会情勢、本サービスの需要、当社の経営環境、その他、諸般の事情により変更の必要があり、変更後の内容が相当である場合、当社が変更内容及び効力発生時期を適切な方法で周知することにより、販売者は、変更後の本規約に同意したものとみなされます。{" "}
                  </div>
                  <div>26. 反社会的勢力の排除</div>
                  <div className="ma-10">
                    各当事者は、自己又はその代表者、役員又は実質的に経営権を有する者が、現在、(a)暴力団、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団、それらの構成員又はこれに準ずる者（以下「反社会的勢力」といいます）、(b) 反社会的勢力でなくなったときから5年を経過しない者、又は（c）反社会的勢力に対する資金提供、便宜の供給、その他密接な関わりを有する者に該当しないことを表明し、かつ、将来にわたっても該当しないことを確約するものとします。{" "}
                  </div>
                  <div>27. 地位譲渡</div>
                  <div className="ma-10">
                    販売者は、当社の書面による事前の承諾なく、本契約上の地位又は権利若しくは義務を譲渡、移転、引受け、担保設定、その他の処分をすることはできません。
                    <br />
                    当社は、本サービスをその方法を問わず事業譲渡する場合、当該事業譲渡に本契約上の地位並びに権利及び義務を当該事業譲渡の相手方に譲渡、移転、引受け、その他、承継することができるものとし、販売者はあらかじめこれを同意します。{" "}
                  </div>
                  <div>28. 準拠法・管轄</div>
                  <div className="ma-10">
                    本契約の準拠法は日本法とします。本契約に関する紛争については、東京地方裁判所を第一審の専属的合意管轄裁判所とします。{" "}
                  </div>
                </div>
                <div className="ma-10">最終更新日：2022年02月02日</div>
              </div>
            </div>
          </section>
        </div>
      </Layout>
    )
  }
}

export default TermsPartnerPage
